var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detail-body" }, [
    _c("div", { staticClass: "main-section" }, [
      _c("div", [
        _c("label", [_vm._v("Event Name")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputFields.name,
              expression: "inputFields.name"
            },
            { name: "validate", rawName: "v-validate" }
          ],
          staticClass: "dark",
          attrs: { type: "text", placeholder: "Event Name", name: "eventName" },
          domProps: { value: _vm.inputFields.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.inputFields, "name", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [_vm._v("Start Date")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputFields.start,
              expression: "inputFields.start"
            },
            { name: "validate", rawName: "v-validate" }
          ],
          staticClass: "dark",
          attrs: {
            type: "text",
            placeholder: "Start Date",
            name: "eventStart"
          },
          domProps: { value: _vm.inputFields.start },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.inputFields, "start", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [_vm._v("End Date")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.inputFields.end,
              expression: "inputFields.end"
            },
            { name: "validate", rawName: "v-validate" }
          ],
          staticClass: "dark",
          attrs: { type: "text", placeholder: "End Date", name: "eventEnd" },
          domProps: { value: _vm.inputFields.end },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.inputFields, "end", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "details-section" }, [
        _c("label", [_vm._v("Details")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "editor-body" },
          [
            _c("quill-editor", {
              directives: [{ name: "validate", rawName: "v-validate" }],
              attrs: { name: "eventDescription" },
              model: {
                value: _vm.inputFields.details,
                callback: function($$v) {
                  _vm.$set(_vm.inputFields, "details", $$v)
                },
                expression: "inputFields.details"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right-section" }, [
      _c("label", [_vm._v("Brand")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("input", {
        staticClass: "dark",
        attrs: { type: "button", value: "Save" },
        on: {
          click: function($event) {
            _vm.save()
          }
        }
      })
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "brand-container" }, [
      _c("div", [
        _c("label", [_vm._v("Primary Color")]),
        _vm._v(" "),
        _c("input", { attrs: { type: "text" } })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [_vm._v("Secondary Color")]),
        _vm._v(" "),
        _c("input", { attrs: { type: "text" } })
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", [_vm._v("Font")]),
        _vm._v(" "),
        _c("input", { attrs: { type: "text" } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "brand-preview" }, [
        _c("label", { staticStyle: { display: "block" } }, [_vm._v("Preview")]),
        _vm._v(" "),
        _c("div", { staticClass: "brand-preview-body" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-067a7d6d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-067a7d6d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/details.vue
// module id = dTeq
// module chunks = 1